angular.module('elfium').constant('COMPANY_FIELD_TYPES', {
	BOOLEAN: ['aktivni', 'parametrElfium', 'parametrHrSluzby', 'parametrZajemKultura', 'parametrZajemSport', 'parametrZajemPfFyz'],
	DATE: []
}).constant('COMPANY_REQUIRED_FIELDS', {
	nazev: 'název',
	zkratka: 'zkratka',
	userId: 'konzultant'
});


// WEBPACK FOOTER //
// ./src/app/components/company/companyConstants.ts